import { toast, Bounce } from 'react-toastify';

export const notifySuccess = (title, id, autoClose = 2000) => {
    toast.success(title, {
      toastId: id,
      transition: Bounce,
      theme: "light",
      closeOnClick: true,
      position: "bottom-right",
      autoClose: autoClose,
      hideProgressBar: false,
      pauseOnHover: false,
    });
}